(function(){
if(window.__mcHomeInit)return; window.__mcHomeInit=1;
function boot(){
try{

const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
const touch=matchMedia('(hover: none)').matches;

/* ============ VIDEO HERO ============ */
const heroVid=document.getElementById('heroVid');
if(heroVid&&heroVid.play)heroVid.play().catch(()=>{});

/* ============ reveals & counters ============ */
/* Content is only hidden once this class lands, so a script that never
   runs leaves the page readable instead of blank. The timer is a second
   net in case IntersectionObserver never fires. */
const mchRoot=document.querySelector('.mch');
if(mchRoot){
  mchRoot.classList.add('js-reveal');
  setTimeout(function(){
    mchRoot.querySelectorAll('.fade:not(.on)').forEach(function(el){el.classList.add('on');});
  },2500);
}

const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('on');io.unobserve(e.target)}}),{threshold:.15});
document.querySelectorAll('section,.fade').forEach(el=>io.observe(el));
const cio=new IntersectionObserver(es=>es.forEach(e=>{
  if(!e.isIntersecting)return;
  const el=e.target,end=+el.dataset.count,t0=performance.now();
  const tick=t=>{const p=Math.min((t-t0)/1600,1);el.textContent=Math.round(end*(1-Math.pow(1-p,3)));if(p<1)requestAnimationFrame(tick)};
  requestAnimationFrame(tick);cio.unobserve(el);
}),{threshold:.5});
document.querySelectorAll('[data-count]').forEach(el=>cio.observe(el));

/* ============ ghost parallax ============ */
const ghosts=[...document.querySelectorAll('.ghost')];
function ghostScroll(){
  ghosts.forEach(g=>{
    const r=g.parentElement.getBoundingClientRect();
    g.style.transform=`translateX(${-r.top*(+g.dataset.plx)}px)`;
  });
}
addEventListener('scroll',ghostScroll,{passive:true});

/* ============ color lab ============ */
const tint=document.getElementById('labTint'),labName=document.getElementById('labName');
document.querySelectorAll('.sw').forEach(b=>b.addEventListener('click',()=>{
  document.querySelectorAll('.sw').forEach(x=>x.classList.remove('act'));b.classList.add('act');
  tint.style.setProperty('background-color',b.dataset.c,'important');labName.textContent=b.dataset.n;
}));
tint.style.setProperty('background-color','transparent','important');

/* ============ gallery drag + velocity skew ============ */
const rail=document.getElementById('rail'),railBar=document.getElementById('railBar');
let isD=false,sx=0,slft=0,lastSL=0,vel=0;
rail.addEventListener('pointerdown',e=>{isD=true;rail.classList.add('dragging');sx=e.clientX;slft=rail.scrollLeft});
addEventListener('pointermove',e=>{if(!isD)return;rail.scrollLeft=slft-(e.clientX-sx)*1.4});
addEventListener('pointerup',()=>{isD=false;rail.classList.remove('dragging')});
(function railLoop(){
  const sl=rail.scrollLeft;vel+=((sl-lastSL)-vel)*.2;lastSL=sl;
  const skew=Math.max(-6,Math.min(6,vel*.35));
  if(!reduced)rail.querySelectorAll('.shot').forEach(s=>s.style.transform=`skewX(${-skew}deg)`);
  const max=rail.scrollWidth-rail.clientWidth,p=max?sl/max:0;
  railBar.style.width='10%';railBar.style.left=(p*90)+'%';
  requestAnimationFrame(railLoop);
})();

/* ============ before/after ============ */
document.querySelectorAll('.ba-frame[data-ba]').forEach(function(fr){
  var top2=fr.querySelector('.ba-top'), h2=fr.querySelector('.ba-handle');
  if(!top2||!h2) return;
  var pos=50, dragging=false;
  function apply(p){pos=Math.max(2,Math.min(98,p));top2.style.clipPath='inset(0 '+(100-pos)+'% 0 0)';h2.style.left=pos+'%';h2.setAttribute('aria-valuenow',Math.round(pos));}
  function fromX(x){var r=fr.getBoundingClientRect();return r.width?((x-r.left)/r.width)*100:50;}
  function end(){if(!dragging)return;dragging=false;fr.classList.remove('ba-dragging');}
  fr.addEventListener('pointerdown',function(e){if(e.button)return;dragging=true;fr.classList.add('ba-dragging');try{fr.setPointerCapture(e.pointerId);}catch(err){}apply(fromX(e.clientX));e.preventDefault();});
  fr.addEventListener('pointermove',function(e){if(dragging)apply(fromX(e.clientX));});
  fr.addEventListener('pointerup',end);
  fr.addEventListener('pointercancel',end);
  fr.addEventListener('lostpointercapture',end);
  addEventListener('pointermove',function(e){if(dragging)apply(fromX(e.clientX));});
  addEventListener('pointerup',end);
  addEventListener('blur',end);
  h2.setAttribute('tabindex','0');
  h2.setAttribute('role','slider');
  h2.setAttribute('aria-label','Drag to compare before and after');
  h2.addEventListener('keydown',function(e){
    if(e.key==='ArrowLeft'){apply(pos-4);e.preventDefault();}
    if(e.key==='ArrowRight'){apply(pos+4);e.preventDefault();}
    if(e.key==='Home'){apply(2);e.preventDefault();}
    if(e.key==='End'){apply(98);e.preventDefault();}
  });
  apply(50);
});

/* ============ FAQ ============ */
document.querySelectorAll('.faq-q').forEach(b=>{
  b.setAttribute('aria-expanded','false');
  b.addEventListener('click',()=>{
    const it=b.parentElement,open=it.classList.contains('open');
    document.querySelectorAll('.faq-item.open').forEach(o=>{o.classList.remove('open');const ob=o.querySelector('.faq-q');if(ob)ob.setAttribute('aria-expanded','false')});
    if(!open){it.classList.add('open');b.setAttribute('aria-expanded','true')}
  });
});

/* ============ scramble text ============ */
const CH='ABCDEFGHIJKLMNOPQRSTUVWXYZ—·';
if(!reduced)document.querySelectorAll('[data-scramble]').forEach(a=>{
  const orig=a.childNodes[0].textContent;
  let iv;
  a.addEventListener('mouseenter',()=>{
    let f=0;clearInterval(iv);
    iv=setInterval(()=>{
      a.childNodes[0].textContent=orig.split('').map((c,i)=>i<f?c:CH[Math.floor(Math.random()*CH.length)]).join('');
      if(f++>=orig.length)clearInterval(iv);
    },28);
  });
});

/* ============ 3D tilt cards ============ */
if(!touch&&!reduced)document.querySelectorAll('.tilt').forEach(c=>{
  c.addEventListener('mousemove',e=>{
    const r=c.getBoundingClientRect();
    const x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;
    c.style.transform=`perspective(1100px) rotateY(${x*5}deg) rotateX(${-y*5}deg) translateY(-4px)`;
  });
  c.addEventListener('mouseleave',()=>c.style.transform='');
});


}catch(e){console.warn('mc-home:',e)}
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();

/* back to top — mobile only, appears after a screen of scrolling */
(function(){
  if (document.querySelector('.mch-top')) return;
  var b = document.createElement('button');
  b.type = 'button';
  b.className = 'mch-top';
  b.setAttribute('aria-label','Back to top');
  b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
  document.body.appendChild(b);

  function update(){
    var y = window.scrollY || document.documentElement.scrollTop || 0;
    b.classList.toggle('on', y > window.innerHeight * 0.8);
  }
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  update();

  b.addEventListener('click', function(){
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
  });
})();
